<template>
  <div>
    <!-- Assessment details (Internal) -->
    <div
      class="tw-p-[40px] tw-text-[15px] tw-flex tw-flex-col tw-gap-[25px] tw-items-start tw-justify-between tw-py-[40px] tw-text-[#211F58]"
    >
      <div class="tw-text-[16px] tw-leading-[130%] tw-font-semibold">
        <div
          class="tw-flex tw-items-center tw-justify-start tw-gap-[10px] tw-text-[#211F58]"
        >
          {{
            getComponentUiText(
              "app-vendor-create-new-vendor-assessment-modal-label-assessment-details-internal-1",
            )
          }}
          <span>
            <ButtonShowDuplicateAssessment
              :id-popover="'popover-assessment-details-internal'"
              :custom-class="'tw-w-[max-content] md:tw-min-w-[500px] md:tw-max-w-[350px] lg:tw-max-w-[470px]'"
              :class="`!tw-p-0 tw-leading-[16px]`"
              :classes="`!tw-leading-none`"
            >
              <div class="tw-p-[25px]">
                <div
                  class="tw-flex tw-flex-col tw-gap-4 tw-text-[11px] tw-font-[400] tw-text-[#231F20]"
                >
                  <div
                    class="tw-text-[14px] tw-font-semibold tw-text-[#211f58] tw-font-poppins"
                  >
                    {{
                      getComponentUiText(
                        "app-vendor-create-new-vendor-assessment-modal-popover-title-assessment-details-internal-1",
                      )
                    }}
                  </div>
                  <CustomDescriptionContent
                    :description="
                      getComponentUiText(
                        'app-vendor-create-new-vendor-assessment-modal-popover-description-assessment-details-internal-1',
                      )
                    "
                    :class="`!tw-p-0 tw-text-[13px] tw-text-[#878787]`"
                  >
                  </CustomDescriptionContent>
                </div>
              </div>
            </ButtonShowDuplicateAssessment>
          </span>
        </div>
        <div
          class="tw-text-[#878787] tw-text-[13px] tw-font-normal tw-leading-normal tw-mt-[10px]"
        >
          {{
            getComponentUiText(
              "app-vendor-create-new-vendor-assessment-modal-label-description-assessment-details-internal-1",
            )
          }}
        </div>
      </div>
      <div
        class="tw-flex tw-items-center tw-justify-between tw-w-full tw-flex-wrap tw-gap-[25px]"
      >
        <div class="tw-flex tw-items-center tw-justify-between tw-w-full">
          <BaseInput
            id="internalDescription"
            v-model="formModel.descInternal"
            :container="'tw-w-full '"
            :class-name="'!tw-items-center !tw-mt-[0px]'"
            :class-name-label="'tw-text-[#231F20]'"
            :label="
              getComponentUiText(
                'app-vendor-create-new-vendor-assessment-modal-label-internal-description-1',
              )
            "
          >
            <div class="input-container email-container tw-flex">
              <div class="input-container tw-grow tw-flex-1">
                <BFormInput
                  v-model="formModel.descInternal"
                  type="text"
                  :placeholder="
                    getComponentUiText(
                      'app-vendor-create-new-vendor-assessment-modal-label-internal-description-placeholder-1',
                    )
                  "
                  :class="['form-control input-base-form-input']"
                  data-cy="assessment-internal-description"
                />
              </div>
            </div>
          </BaseInput>
        </div>
        <div class="tw-flex tw-items-center tw-justify-between tw-w-full">
          <BaseInput
            id="internalNotes"
            v-model="formModel.notesInternal"
            :container="'tw-w-full '"
            :class-name="'!tw-items-center !tw-mt-[0px]'"
            :class-name-label="'tw-text-[#231F20]'"
            :label="
              getComponentUiText(
                'app-vendor-create-new-vendor-assessment-modal-label-internal-notes-1',
              )
            "
            :placeholder="
              getComponentUiText(
                'app-vendor-create-new-vendor-assessment-modal-label-internal-notes-1',
              )
            "
          >
            <div class="input-container email-container tw-flex">
              <div class="input-container tw-grow tw-flex-1">
                <textarea
                  ref="autoTextarea"
                  v-model="formModel.notesInternal"
                  :placeholder="
                    getComponentUiText(
                      'app-vendor-create-new-vendor-assessment-modal-label-internal-notes-placeholder-1',
                    )
                  "
                  :style="`outline-color : #EFF0F1`"
                  data-cy="assessment-internal-notes"
                  class="tw-w-full auto-expand tw-min-h-[82px] tw-text-[13px] tw-font-normal tw-leading-none tw-px-5 tw-py-[18px] tw-rounded-md tw-border-solid tw-border-[#EFF0F1] tw-bg-[#eff0f180] tw-text-[#231F20]"
                  @input="autoResize"
                ></textarea>
              </div>
            </div>
          </BaseInput>
        </div>
      </div>
    </div>

    <!-- Assessment details (Vendor) -->
    <div
      class="tw-border-0 tw-border-t-[1px] tw-border-solid tw-border-[#EFF0F1] tw-p-[40px] tw-text-[15px] tw-flex tw-flex-col tw-gap-[25px] tw-items-start tw-justify-between tw-py-[40px] tw-text-[#211F58]"
    >
      <div class="tw-text-[16px] tw-leading-[130%] tw-font-semibold">
        <div
          class="tw-flex tw-items-center tw-justify-start tw-gap-[10px] tw-text-[#211F58]"
        >
          {{
            getComponentUiText(
              "app-vendor-create-new-vendor-assessment-modal-label-assessment-details-vendor-1",
            )
          }}
          <span>
            <ButtonShowDuplicateAssessment
              :id-popover="'popover-assessment-details-vendor'"
              :custom-class="'tw-w-[max-content] md:tw-min-w-[500px] md:tw-max-w-[350px] lg:tw-max-w-[470px]'"
              :class="`!tw-p-0 tw-leading-[16px]`"
              :classes="`!tw-leading-none`"
            >
              <div class="tw-p-[25px]">
                <div
                  class="tw-flex tw-flex-col tw-gap-4 tw-text-[11px] tw-font-[400] tw-text-[#231F20]"
                >
                  <div
                    class="tw-text-[14px] tw-font-semibold tw-text-[#211f58] tw-font-poppins"
                  >
                    {{
                      getComponentUiText(
                        "app-vendor-create-new-vendor-assessment-modal-popover-title-assessment-details-vendor-1",
                      )
                    }}
                  </div>
                  <CustomDescriptionContent
                    :description="
                      getComponentUiText(
                        'app-vendor-create-new-vendor-assessment-modal-popover-description-assessment-details-vendor-1',
                      )
                    "
                    :class="`!tw-p-0 tw-text-[13px] tw-text-[#878787]`"
                  >
                  </CustomDescriptionContent>
                </div>
              </div>
            </ButtonShowDuplicateAssessment>
          </span>
        </div>
        <div
          class="tw-text-[#878787] tw-text-[13px] tw-font-normal tw-leading-normal tw-mt-[10px]"
        >
          {{
            getComponentUiText(
              "app-vendor-create-new-vendor-assessment-modal-label-description-assessment-details-vendor-1",
            )
          }}
        </div>
      </div>
      <div
        class="tw-flex tw-items-center tw-justify-between tw-w-full tw-flex-wrap tw-gap-[25px]"
      >
        <div class="tw-flex tw-items-center tw-justify-between tw-w-full">
          <BaseInput
            id="assessmentDescription"
            v-model="formModel.descExternal"
            :container="'tw-w-full '"
            :class-name="'!tw-items-center !tw-mt-[0px]'"
            :class-name-label="'tw-text-[#231F20]'"
            :label="
              getComponentUiText(
                'app-vendor-create-new-vendor-assessment-modal-label-assessment-description-1',
              )
            "
            :placeholder="
              getComponentUiText(
                'app-vendor-create-new-vendor-assessment-modal-label-internal-description-placeholder-1',
              )
            "
          >
            <div class="input-container email-container tw-flex">
              <div class="input-container tw-grow tw-flex-1">
                <BFormInput
                  v-model="formModel.descExternal"
                  type="text"
                  data-cy="assessment-external-description"
                  :placeholder="
                    getComponentUiText(
                      'app-vendor-create-new-vendor-assessment-modal-label-internal-description-placeholder-1',
                    )
                  "
                  :class="['form-control input-base-form-input']"
                />
              </div>
            </div>
          </BaseInput>
        </div>
        <div class="tw-flex tw-items-center tw-justify-between tw-w-full">
          <BaseInput
            id="assessmentNotes"
            v-model="formModel.notesExternal"
            :container="'tw-w-full '"
            :class-name-label="'tw-text-[#231F20]'"
            :class-name="'!tw-items-center !tw-mt-[0px]'"
            :label="
              getComponentUiText(
                'app-vendor-create-new-vendor-assessment-modal-label-assessment-instructions-1',
              )
            "
            :placeholder="'Assessment notes'"
          >
            <div class="input-container email-container tw-flex">
              <div class="input-container tw-grow tw-flex-1">
                <textarea
                  ref="autoTextarea"
                  v-model="formModel.notesExternal"
                  data-cy="assessment-external-notes"
                  :placeholder="
                    getComponentUiText(
                      'app-vendor-create-new-vendor-assessment-modal-instructions-for-vendor-placeholder-1',
                    )
                  "
                  :style="`outline-color : #EFF0F1`"
                  class="tw-w-full auto-expand tw-min-h-[82px] tw-text-[13px] tw-font-normal tw-leading-none tw-px-5 tw-py-[18px] tw-rounded-md tw-border-solid tw-border-[#EFF0F1] tw-bg-[#eff0f180] tw-text-[#231F20]"
                  @input="autoResize"
                ></textarea>
              </div>
            </div>
          </BaseInput>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { getComponentUiText } from "@/utils/utilities";
import { reactive, ref, watch, defineExpose } from "vue";
import { BFormInput } from "bootstrap-vue-next";
import { useVuelidate } from "@vuelidate/core";
import BaseInput from "../common/form/baseInput.vue";
import ButtonShowDuplicateAssessment from "../common/setting/buttonShowDuplicateAssessment.vue";
import CustomDescriptionContent from "../common/customDescriptionContent.vue";

const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
});
const autoTextarea = ref<HTMLTextAreaElement | null>(null);
const formModel = reactive({
  ...props.modelValue,
});

const emit = defineEmits(["update:isDisabled", "update:modelValue"]);

const rules = {
  internalDescription: {},
  internalNotes: {},
  assessmentDescription: {},
  assessmentNotes: {},
};

const $v = useVuelidate(rules, formModel as any);

watch(
  () => formModel,
  (value) => {
    emit("update:modelValue", value);
  },
  { deep: true },
);

const isCheckValid = async () => {
  await $v.value.$validate();
  if ($v.value.$invalid) return;
  return;
};

const autoResize = () => {
  if (autoTextarea.value) {
    autoTextarea.value.style.height = "auto"; // Reset height
    autoTextarea.value.style.height = autoTextarea.value.scrollHeight + "px"; // Set height based on content
  }
};

defineExpose({
  isCheckValid,
});
</script>

<style scoped>
input::placeholder {
  color: #878787;
  font-size: 13px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
</style>
